<template>
  <div>
    <verify-email-lender-desktop v-if="!isMobile" />
    <verify-email-lender-mobile v-else />
  </div>
</template>
<script>
import VerifyEmailLenderDesktop from "./Desktop/VerifyEmailLender-Desktop.vue";
import VerifyEmailLenderMobile from "./Mobile/VerifyEmailLender-Mobile.vue";

export default {
  components: { VerifyEmailLenderDesktop, VerifyEmailLenderMobile },
  data() {
    return {};
  },
  computed: {
    isMobile() {
      if (window.innerWidth >= 500) {
        return false;
      } else {
        return true;
      }
    },
  },
};
</script>
<style scoped></style>
